import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { isScrollingDisabled } from '../../ducks/ui.duck';
import buyerGuideContent from '../../content/buyerGuideContent';

import {
  StaticContentArticle,
  StaticContentPageLayout,
} from '../StaticContentPage/StaticContentPage';

export const BuyerGuideContent = props => (
  <StaticContentArticle content={buyerGuideContent} {...props} />
);

export const BuyerGuidePageComponent = props => {
  const { scrollingDisabled } = props;

  return (
    <StaticContentPageLayout content={buyerGuideContent} scrollingDisabled={scrollingDisabled}>
      <BuyerGuideContent />
    </StaticContentPageLayout>
  );
};

BuyerGuidePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => ({
  scrollingDisabled: isScrollingDisabled(state),
});

const BuyerGuidePage = compose(connect(mapStateToProps))(BuyerGuidePageComponent);

export default BuyerGuidePage;
